
import React, { ReactNode, useState } from 'react';
import axios from 'axios';
// import '../Pincodefinder/Style.css';
import '../Pincodefinder/Track.css';
// import '../Steelcity/css/style.css';
// import '../Steelcity/css/bootstrap.min.css';
// import '../Steelcity/css/responsive.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Row, Col, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';
import personPhoto from "../Logo/personPhoto.png";
import jdcargo from "../Logo/jdcargologo.png";
import serviceIcon from "../Logo/service247.png";
import banner from "../Logo/banner.jpg";


interface TempodEntry {
  EntryDate: string;
  EntryTime: string;
  Details: string;
  Remark: string;
}

interface TrackingRecord {
  CNoteNo: string;
  InvoiceNo: string;
  ExptDateDelivery: string;
  ForwardingNo: string;
  bookdate: string;
  ConsigneeName: string;
  Status: string;
  Qty: string;
  Destination_Name: string;
  Origin_Name: string;
  Mode: string;
  EWaybill: string,
  recvName: string;
  statusDt: string;
  delvTime: string;
  remark: ReactNode;
  tempodData: TempodEntry[];
  ImageLink: string;
}

const Track: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const [trackingData, setTrackingData] = useState<TrackingRecord[]>([]);
  const [showImage, setShowImage] = useState(false);
  const [error, setError] = useState('');
  const [currentStep, setCurrentStep] = useState(1);
  const [menuOpen, setMenuOpen] = useState(false);


  // const news = [
  //   {
  //     date: '10/09/2021',
  //     title: 'JD Cargo Held Exciting Programs for Courier Services',
  //     link: '#',
  //     isNew: true,
  //   },
  //   {
  //     date: '01/04/2021',
  //     title: 'Thanks to JD Cargo Employees for COVID-19 Contribution',
  //     link: '#',
  //     isNew: true,
  //   },
  //   {
  //     date: '10/04/2020',
  //     title: 'Employees Always Wear Mask in Company Premises',
  //     link: '#',
  //   },
  //   {
  //     date: '08/06/2020',
  //     title: 'Shipment Delayed in Delhi Due to COVID Restrictions',
  //     link: '#',
  //   },
  //   {
  //     date: '02/03/2022',
  //     title: 'JD Cargo Expands Operations to South India Region',
  //     link: '#',
  //     isNew: true,
  //   },
  //   {
  //     date: '11/09/2022',
  //     title: 'New Partnership Signed with Leading E-commerce Platforms',
  //     link: '#',
  //   },
  //   {
  //     date: '06/02/2023',
  //     title: 'JD Cargo Introduces Contactless Delivery System',
  //     link: '#',
  //   },
  //   {
  //     date: '08/05/2023',
  //     title: 'JD Cargo Launches Eco-friendly Packaging Initiative',
  //     link: '#',
  //   },
  //   {
  //     date: '15/08/2024',
  //     title: 'JD Cargo Celebrates Independence Day with Blood Donation Drive',
  //     link: '#',
  //     isNew: true,
  //   },
  // ];


  const statusToStep: { [key: string]: number } = {
    Shipped: 1,
    'In Transit': 2,
    Delivered: 3,
  };

  const handleButtonClick = () => setShowImage(!showImage);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.slice(0, 200);
    setSearchValue(inputValue);
    setError('');
    setTrackingData([]);
  };



  const fetchData = async () => {
    try {
      setError(""); // clear previous error

      if (searchValue.trim() === "") {
        setError("Please enter one or more tracking numbers separated by commas.");
        alert("Please enter one or more tracking numbers separated by commas.");
        return;
      }

      const searchInputs = searchValue
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);

      if (searchInputs.length === 0) {
        setError("Please enter valid tracking numbers or reference numbers.");
        alert("Please enter valid tracking numbers or reference numbers.");
        return;
      }

      const res = await axios.get(
        "https://jdcargo.co.in/JdcargoTrackingApi/getTrackingData",
        {
          params: {
            CNoteNo: searchInputs.join(","),
            refNo: searchInputs.join(","),
          },
        }
      );

      const data = res.data;

      if (data.status === 1 && data.Data) {
        const updatedData = data.Data.map((item: TrackingRecord) => ({
          ...item,
          ImageLink: `https://jdcargo.co.in/PODImg/POD_Image/${item.CNoteNo}.jpg`,
        }));

        setTrackingData(updatedData);
        setSearchValue("");

        if (updatedData.length > 0) {
          setCurrentStep(statusToStep[updatedData[0].Status] || 1);
        }
      } else {
        setTrackingData([]);
        setError("Docket Not Found");
        alert("Docket Not Found");
        setSearchValue("");
      }
    } catch (err: any) {
      console.error(err);

      const message =
        err.response?.data?.message ||
        "Failed to fetch data. Please check your internet connection or try again later.";

      setError(message);
      alert(message);
      setSearchValue("");
    }
  };



  return (
    <>


      <header className="navbar-desktop">
        <div className="navbar-right">
          <div className="person-photo-wrapper">
            <img src={personPhoto} alt="Person" className="personPhoto" />
          </div>

        </div>

        <div className="navbar-left">
          <img
            src={jdcargo}
            alt="JD Cargo Logo"
            style={{
              height: window.innerWidth < 768 ? "34px" : "48px",
              width: "auto",
              objectFit: "contain"
            }}
          />


        </div>

        <nav className="navbar-center">
          <a href="https://jdcargo.co.in/index.php">Home</a>
          <a href="https://jdcargo.co.in/about-us.php">About Us</a>
          <a href="https://jdcargo.co.in/our-services.php">Services</a>
          <a href="https://jdcargo.co.in/track/">Tracking</a>
          <a href="https://jdcargo.co.in/contact-us.php">Contact Us</a>
          <div className="dropdown">
            <a href="#" className="dropdown-link">More ▾</a>

            <div className="dropdown-menu">
                <a href="https://jdcargo.co.in/tat.php">TAT</a>
                <a href="https://jdcargo.co.in/domestic-documentation.php">Domestic Documentation</a>
                <a href="https://jdcargo.co.in/vas.php">VAS (Value Added Services)</a>
                <a href="https://jdcargo.co.in/gallery.php">Gallery</a>
            </div>
          </div>

        </nav>

        <div className="navbar-right">
          <img src={serviceIcon} alt="24/7 Service" className="service-icon" />
        </div>
      </header>

      {/* Mobile Navbar */}
      <header className="navbar-mobile">
        <div className="mobile-header">
          <button
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
          <div className="navbar-right">
            <div className="person-photo-wrapper">
              <img src={personPhoto} alt="Person" className="personPhoto2" />
            </div>

          </div>

          <img src={jdcargo} alt="JD Cargo Logo" className="mobile-logo2" />
        </div>

        {menuOpen && (
          <div className="mobile-menu">
            <a href="https://jdcargo.co.in/index.php">Home</a>
            <a href="https://jdcargo.co.in/about-us.php">About Us</a>
            <a href="https://jdcargo.co.in/our-services.php">Services</a>
            <a href="https://jdcargo.co.in/tracking.php">Tracking</a>
            <a href="https://jdcargo.co.in/contact-us.php">Contact Us</a>
            <div className="dropdown">
              <a href="#">More ▾</a>
              <div className="dropdown-menu">
                <a href="https://jdcargo.co.in/tat.php">TAT</a>
                <a href="https://jdcargo.co.in/domestic-documentation.php">Domestic Documentation</a>
                <a href="https://jdcargo.co.in/vas.php">VAS (Value Added Services)</a>
                <a href="https://jdcargo.co.in/gallery.php">Gallery</a>
              </div>
            </div>

          </div>
        )}
      </header>
      
      <div
        style={{
          position: "relative",
          width: "100%",
          height: window.innerWidth < 768 ? "300px" : "520px", // desktop thoda kam
          overflow: "hidden",
        }}
      >
        {/* Banner */}
        <img
          src={banner}
          alt="banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />

        {/* Dark overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 1,
          }}
        />

        {/* Track bar */}
        <div
          style={{
            position: "absolute",
            left: "53%",
            bottom: window.innerWidth < 768 ? "20px" : "80px", // desktop slightly up
            transform: "translateX(-50%)",
            background: "#ffffff",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            width: window.innerWidth < 768 ? "92%" : "460px", // 🔽 desktop width reduced
            boxShadow: "0 6px 20px rgba(0,0,0,0.35)",
            overflow: "hidden",
            zIndex: 2,
          }}
        >
          <input
            type="text"
            placeholder="Enter AWB Number"
            value={searchValue}
            onChange={handleInputChange}
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              padding: window.innerWidth < 768 ? "10px 12px" : "14px 18px", // 🔽 desktop padding reduced
              fontSize: window.innerWidth < 768 ? "13px" : "15px",         // 🔽 desktop font slightly smaller
              color: "#333",
            }}
          />

          <button
            onClick={fetchData}
            style={{
              background: "#0b2c4d",
              color: "#ffffff",
              border: "none",
              padding: window.innerWidth < 768 ? "10px 14px" : "14px 22px", // 🔽 desktop button smaller
              fontSize: window.innerWidth < 768 ? "13px" : "15px",
              fontWeight: "600",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            Track Shipment
          </button>
        </div>
      </div>






      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-10 col-sm-12">
            <h5 className="BLuedarttracking1 text-center"><b>JD Cargo Tracking Details</b></h5>

            {trackingData.length > 0 ? (
              trackingData.map((record, index) => (
                <div key={index} className="p-4 mb-4">
                  <div className="table-responsive-custom">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>Waybill No</th>
                          <th>Invoice No</th>
                          <th>Expected Date of Delivery</th>
                          <th>Status</th>
                          <th>Date of Delivery</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{record.CNoteNo}</td>
                          <td>{record.InvoiceNo}</td>
                          <td>{record.ExptDateDelivery}</td>
                          <td>{record.Status}</td>
                          <td>{record.statusDt}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              ))
            ) : (
              <div className="text-center">No tracking data available.</div>
            )}

            {/* Progress Steps */}
            <div className="steps-wrapper">
              <div className="steps-container">
                {[1, 2, 3].map((number) => (
                  <div key={number} className="step">
                    <div className={`step-circle2 ${number <= currentStep ? 'active' : ''}`}>
                      {number}
                    </div>
                    <div className="step-label">
                      {number === 1 ? 'Shipped' : number === 2 ? 'In Transit' : 'Delivered'}
                    </div>
                  </div>
                ))}

                {/* Progress line */}
                <div className="progress-line">
                  <div
                    className="progress-fill"
                    style={{ width: `${((currentStep - 1) / 2) * 100}%` }}
                  ></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


      {/* Tabs Section */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-10 col-sm-12">
            <Tabs defaultActiveKey="details" id="uncontrolled-tab-example" className="custom-tabs">
              {/* Shipment Details Tab */}
              <Tab eventKey="details" title="Shipment Details">
                {trackingData.length > 0 ? (
                  trackingData.map((record, index) => (

                    <div key={index} className="mb-4">
                      <div className="shipment-table-container">
                        <table className="blue-table">
                          <thead className='blue-table'>
                            <tr>
                              <th className="blue-header">Shipment Details</th>
                              <th className="blue-header">Details</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr><td>Waybill No</td><td>{record.CNoteNo}</td></tr>
                            <tr><td>Forwarding No</td><td>{record.ForwardingNo || '-'}</td></tr>
                            <tr><td>Pickup Date</td><td>{record.bookdate}</td></tr>
                            <tr><td>From</td><td>{record.Origin_Name}</td></tr>
                            <tr><td>To</td><td>{record.Destination_Name}</td></tr>
                            <tr><td>Qty</td><td>{record.Qty}</td></tr>
                            <tr><td>EWaybill</td><td>{record.EWaybill}</td></tr>
                            <tr><td>Status</td><td>{record.Status}</td></tr>
                            <tr><td>Date of Delivery</td><td>{record.statusDt || '-'}</td></tr>
                          </tbody>
                        </table>
                      </div>




                      {/* Show/Hide POD Button */}
                      <button className="pod-btn-blue mt-3" onClick={handleButtonClick}>
                        {showImage ? "Hide Image" : "Show POD Image"}
                      </button>

                      {/* POD Image */}
                      {showImage && record.ImageLink && (
                        <div className="image-container mt-3 text-center">
                          <img
                            src={record.ImageLink}
                            alt="POD"
                            className=""
                            style={{ maxWidth: "600px", borderRadius: "6px" }}
                          />
                        </div>
                      )}
                    </div>


                  ))
                ) : (
                  <div className="text-center">No shipment details available.</div>
                )}
              </Tab>

              {/* Status and Scans Tab */}

              <Tab eventKey="status" title="Status and Scans">
                {trackingData.length > 0 ? (
                  trackingData.map((record, index) => (
                    <div key={index} className="mb-3">
                      <div className="scrollable-table">
                        <table className="blue-table">
                          <thead>
                            <tr>
                              <th>Location</th>
                              <th>Status</th>
                              <th>Date</th>
                              <th>Time</th>
                            </tr>
                          </thead>

                          <tbody>
                            {record.tempodData && record.tempodData.length > 0 ? (
                              record.tempodData.map((entry, idx) => (
                                <tr key={idx}>
                                  <td>{entry.Details}</td>
                                  <td>{entry.Remark}</td>
                                  <td>{entry.EntryDate}</td>
                                  <td>{entry.EntryTime}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4}>No scans available.</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center">No status and scans available.</div>
                )}
              </Tab>

            </Tabs>
          </div>
        </div>
      </div>


      {/* News Section */}
      {/* <div className="container mt-4">
        <div className="marquee-container">
          <div className="marquee-content">
            <Row className="flex-nowrap">
              {news.map((item, idx) => (
                <Col key={idx} className="marquee-col" style={{ position: "relative" }}>
                  <Card
                    className="shadow-sm border-0 h-100 position-relative"
                    style={{
                      borderRadius: "15px",
                      padding: "20px",
                      textAlign: "left",
                      overflow: "hidden",
                    }}
                  >
                    <span className="new-badge">NEW</span>
                    <Card.Body>
                      <Card.Title style={{ fontWeight: "700", fontSize: "1.2rem", color: "#222" }}>
                        {item.date}
                      </Card.Title>
                      <Card.Text>
                        <a href={item.link} style={{ color: "#007bff", textDecoration: "none", fontWeight: "500" }}>
                          {item.title}
                        </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </div> */}



      {/* Footer */}

      <footer className="jd-footer">
        <div className="container">
          <div className="row">

            {/* Column 1 */}
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <img src={jdcargo} alt="JD Cargo Logo" className="jd-footer-logo" />

              <p>
                We are committed and dedicated in fulfilling our obligation to our valued customer by offering quality services that meets all the demands and day to day requirements of our clients, which makes us a reputed courier and cargo company in India... Read More
              </p>

              <div className="jd-social">
                <a href="#"><i className="fab fa-instagram"></i></a>
                <a href="#"><i className="fab fa-facebook"></i></a>
              </div>
            </div>

            {/* Column 2 */}
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="https://jdcargo.co.in/index.php">Home</a></li>
                <li><a href="https://jdcargo.co.in/about-us.php">About Us</a></li>
                <li><a href="https://jdcargo.co.in/our-services.php">Our Services</a></li>
                <li><a href="https://jdcargo.co.in/Premium-Air.php">Premium Air</a></li>
                <li><a href="https://jdcargo.co.in/contact-us.php">Contact Us</a></li>
              </ul>
            </div>

            {/* Column 3 */}
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <h4>Our Services</h4>
              <ul>
                <li><a href="https://jdcargo.co.in/tat.php">TAT</a></li>
                <li><a href="https://jdcargo.co.in/domestic-documentation.php">Domestic Document</a></li>
                <li><a href="https://jdcargo.co.in/vas.php">Value Added Services</a></li>
                <li><a href="https://jdcargo.co.in/gallery.php">Gallery</a></li>
              </ul>
            </div>

            {/* Column 4 */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <h4>Get in Touch</h4>
              <p>
                C-4 Udyog Sadan 1, Road no.2, MIDC Central Road, Mulgaon, Andheri (East), Mumbai 400093, INDIA
              </p>
              <p>
                <strong>Email:</strong> info@jdcargo.co.in <br />
                Contact: 022-65166111, +91 9619199965, +91 8879375386, +91 9870813466 <br />
                <a href="mailto:jdcouriersandcargo@gmail.com">jdcouriersandcargo@gmail.com</a>
              </p>
            </div>

          </div>
        </div>



        <div className="jd-footer-bottom">
          © JD Couriers and Cargo Pvt Ltd 2020
        </div>
      </footer>

    </>
  );
};

export default Track;
